import React from 'react';
import Icon, { IconName } from '../Icon';
import { useTranslation } from '../../i18n';
import { TabType } from '../../hooks/useNavigation';
import './BottomNav.css';

interface BottomNavProps {
  activeTab: TabType | null;
  onTabChange: (tab: TabType) => void;
  onAddGoal: () => void;
}

const TABS_BEFORE_ADD: Array<{ tab: TabType; icon: IconName }> = [
  { tab: 'home', icon: 'home' },
  { tab: 'goals', icon: 'goal' },
];

const TABS_AFTER_ADD: Array<{ tab: TabType; icon: IconName }> = [
  { tab: 'timely', icon: 'clock' },
  { tab: 'achievements', icon: 'trophy' },
];

const BottomNav: React.FC<BottomNavProps> = ({ activeTab, onTabChange, onAddGoal }) => {
  const { t } = useTranslation();

  const renderTab = ({ tab, icon }: { tab: TabType; icon: IconName }) => {
    const isActive = activeTab === tab;
    return (
      <button
        key={tab}
        type="button"
        className={`bottom-nav__item${isActive ? ' is-active' : ''}`}
        onClick={() => onTabChange(tab)}
        aria-current={isActive ? 'page' : undefined}
      >
        <Icon name={icon} className="bottom-nav__icon" />
        <span className="bottom-nav__label">{t(`navigation.short.${tab}`)}</span>
      </button>
    );
  };

  return (
    <nav className="bottom-nav" aria-label={t('navigation.mainNav')}>
      {TABS_BEFORE_ADD.map(renderTab)}
      <div className="bottom-nav__add-slot">
        <button
          type="button"
          className="bottom-nav__add"
          onClick={onAddGoal}
          aria-label={t('goals.addNew')}
        >
          <Icon name="plus" />
        </button>
      </div>
      {TABS_AFTER_ADD.map(renderTab)}
    </nav>
  );
};

export default BottomNav;
